import type { ReactNode } from 'react';
import { joinClasses, tableStyles } from './styles';

interface Props {
  className?: string;
  children: ReactNode;
}

export default function TableRow({ className, children }: Props) {
  return <tr className={joinClasses(tableStyles.row, className)}>{children}</tr>;
}
